module.exports = __webpack_public_path__ + "img/transaksi_saldo_nett.bfb7f7db.svg";